import React from 'react';
export function TopBar() {
  return <div className="bg-deco-warm text-deco-text py-2 px-4 text-center text-xs sm:text-sm font-semibold tracking-wide" data-id="element-207" data-mp="3sdwyhb040hms">
      <p data-id="element-208" data-mp="234zyj2e0o8dm">Producto 100% digital · Descarga inmediata</p>
    </div>;
}